import classnames from 'classnames';
import { MapboxStyles } from 'constants/map';
import React, { FC, ReactNode } from 'react';

type ToggleItemProps = {
  id?: string;
  children?: ReactNode;
  value: MapboxStyles;
  mapStyle: MapboxStyles;
  onClick: (nextStyle: MapboxStyles) => void;
  name: string;
};

const ToggleItem: FC<ToggleItemProps> = ({
  id,
  children,
  mapStyle,
  onClick,
  name,
  value,
}: ToggleItemProps) => {
  const defaultClass =
    'flex justify-center items-center hrem-6 wrem-6 b-radius-3 mx2 bgd-light-grey-1 oh cursor-pointer';
  const className = classnames(defaultClass, {
    [`${defaultClass} b-primary b-solid`]: mapStyle === value,
  });
  return (
    <div id={id} onClick={() => onClick(value)}>
      <div className={className} style={{ borderWidth: 2 }}>
        {children}
      </div>
      <p className="flex font-size-2 justify-center mt1">{name}</p>
    </div>
  );
};

export default ToggleItem;
